import { ProductIcon } from '@/lib/misc/ProductIcons'
import type { ReactElement } from 'react'
import { KNOWLEDGE_BASE_LINKS } from './constants'

export interface ServiceItemInterface {
  id: string
  title: string
  description: string
  cta?: string
  icon?: ReactElement
  knowledgeBaseUrl?: string
}

export const ICON_SIZE = 24

export const ServicesItems: ServiceItemInterface[] = [
  {
    id: 'ip_transit',
    title: 'IP-Transit',
    description:
      'Bring your own ASN and get connected to our expanding network with transparent billing including 95th percentile or flat rate.',
    cta: '/services/ip-transit',
    icon: <ProductIcon productId="ip_transit" size={ICON_SIZE} />,
    knowledgeBaseUrl: KNOWLEDGE_BASE_LINKS.IP_TRANSIT,
  },
  {
    id: 'ip_access',
    title: 'IP-Access',
    description:
      'A customizable, flexible connectivity solution for businesses, legacy installations, and campuses has arrived.',
    cta: '/services/ip-access',
    icon: <ProductIcon productId="ip_access" size={ICON_SIZE} />,
    knowledgeBaseUrl: KNOWLEDGE_BASE_LINKS.IP_ACCESS,
  },
  {
    id: 'flex_ethernet',
    title: 'Flex Ethernet',
    description:
      'Connect between two or more Inter.link PoPs with full transparency, path protection and redundancy as default.',
    cta: '/services/flex-ethernet',
    icon: <ProductIcon productId="flex_ethernet" size={ICON_SIZE} />,
    knowledgeBaseUrl: KNOWLEDGE_BASE_LINKS.FLEX_ETHERNET,
  },

  {
    id: 'ddos_protection',
    title: 'DDoS Protection',
    description:
      'DDoS Protection helps safeguard your network infrastructure\n' +
      'against malicious traffic and potential cyber attacks.',
    cta: '/services/ddos-protection',
    icon: <ProductIcon productId="ddos_protection" size={ICON_SIZE} />,
    knowledgeBaseUrl: KNOWLEDGE_BASE_LINKS.DDOS_PROTECTION,
  },
  {
    id: 'ip_transit_over_gre',
    title: 'FlexTunnel',
    description:
      'Establish a GRE tunnel to enable add-on services such as DDoS protection, with dedicated bandwidth and custom routing.',
    cta: '/services/flex-tunnel',
    icon: <ProductIcon productId="cloud_swap" size={ICON_SIZE} />,
    knowledgeBaseUrl: KNOWLEDGE_BASE_LINKS.FLEX_TUNNEL,
  },
  {
    id: 'cloud_connect',
    title: 'Cloud Connect',
    description:
      'Connect directly to your cloud provider with a private, low-latency handoff instead of routing over the public internet.',
    cta: '/services/cloud-connect',
    icon: <ProductIcon productId="cloud_connect" size={ICON_SIZE} />,
  },
  // {
  //   id: 'extensions',
  //   title: 'Extensions',
  //   description:
  //     'Extensions are a way to connect your services to the internet, without the need for a physical connection.',
  //   cta: '/services/extension',
  //   icon: <PulseRegular fontSize={24} />,
  // },
  // {
  //   id: 'office_fiber',
  //   title: 'Office Fiber',
  //   description:
  //     'Office Fiber delivers IP-Access/Transit services directly to buildings, while Inter.link handles fiber connectivity, project management, and service handover.',
  // },
]
